<script setup>
    import AnswerRates from '@/components/result/ai-literacy/AnswerRates.vue';
    import SubareaGuide from '@/components/result/ai-literacy/SubareaGuide.vue';
    
    const ourClassPercentages = [85, 70, 20, 65]; 
    const overallPercentages = [75, 35, 80, 70];
    const userRole = 'parent';
</script>
<template>
    <div class="report-inner">   
        <div class="card-wrap">           
            <AnswerRates                
                :our-class-percentages="ourClassPercentages"
                :overall-percentages="overallPercentages"               
                :userRole="userRole"
            />            
            <SubareaGuide :userRole="userRole" />
        </div>        
    </div>
</template>